import React from 'react';
import { Grid, Input } from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import { useFormikContext } from 'formik';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import frLocale from 'date-fns/locale/fr';
import arLocale from 'date-fns/locale/ar';
import { useIntl } from 'react-intl';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { useSelector } from 'react-redux';
import { LANGUAGES } from 'store/LanguageProvider/constants';
import { ErrorTitle, PrimaryTitleCard, useStyles } from './styles';

const ComplementInputs = () => {
  const classes = useStyles();
  const { setFieldValue, values, errors } = useFormikContext<any>();
  const intl = useIntl();
  const lang = useSelector(getLocaleSelector);

  return (
    <MuiPickersUtilsProvider
      utils={DateFnsUtils}
      locale={lang === LANGUAGES.AR ? arLocale : frLocale}
    >
      <Grid container spacing={2} style={{ maxWidth: 550 }}>
        <Grid item xs={12} lg={12} md={12}>
          <PrimaryTitleCard style={{ marginBottom: 10 }} fontSize="14px">
            {intl.formatMessage({ id: 'dmo.info.complement' })}
          </PrimaryTitleCard>
        </Grid>

        <Grid item xs={12} lg={12} md={12}>
          <Input
            placeholder={intl.formatMessage({ id: 'dmo.info.frais' })}
            className={classes.inputTextStyle2}
            disableUnderline={true}
            startAdornment={<></>}
            value={values.fraisEngagement}
            onChange={(e) => {
              /* istanbul ignore next */
              if (e.target.value !== '' && /^[0-9,.]+$/.test(e.target.value)) {
                setFieldValue('fraisEngagement', e.target.value);
              } else if (e.target.value === '') {
                setFieldValue('fraisEngagement', '');
              }
            }}
            name="fraisEngagement"
          />
          {values.fraisEngagement !== '' && (
            <ErrorTitle>
              {errors['fraisEngagement'] && errors['fraisEngagement']}
            </ErrorTitle>
          )}
        </Grid>

        <Grid item xs={12} lg={12} md={12}>
          <PrimaryTitleCard fontSize="14px">
            {intl.formatMessage({
              id: 'dmo.info.open.calendar',
            })}
          </PrimaryTitleCard>
        </Grid>

        <Grid item xs={12} lg={12} md={12}>
          <KeyboardDatePicker
            variant="dialog"
            inputVariant="outlined"
            className={classes.inputDateStyle}
            format="dd/MM/yyyy"
            placeholder={intl.formatMessage({
              id: 'dmo.info.consultation.date',
            })}
            value={values.dateConsultation}
            onChange={
              /* istanbul ignore next */ (e) =>
                setFieldValue('dateConsultation', e)
            }
            name="dateConsultation"
            cancelLabel={intl.formatMessage({ id: 'addContract.cancel' })}
            okLabel={intl.formatMessage({
              id: 'dmo.info.consultation.date.ok',
            })}
            invalidDateMessage={intl.formatMessage({
              id: 'Input.Error.Date',
            })}
          />
          {values.dateConsultation !== null && (
            <ErrorTitle>
              {errors['dateConsultation'] && errors['dateConsultation']}
            </ErrorTitle>
          )}
        </Grid>
        <Grid item xs={12} lg={6} md={6}>
          <Input
            placeholder={intl.formatMessage({
              id: 'dmo.info.consultation.email',
            })}
            className={classes.inputTextStyle2}
            disableUnderline={true}
            name="email"
            value={values.email}
            onChange={
              /* istanbul ignore next */ (e) => {
                if (
                  e.target.value !== '' &&
                  /^[\w@.+_-]*$/.test(e.target.value)
                ) {
                  setFieldValue('email', e.target.value);
                } else if (e.target.value === '') {
                  setFieldValue('email', '');
                }
              }
            }
            style={{ backgroundColor: 'rgb(220, 220, 220)' }}
          />
          <ErrorTitle>{errors['email'] && errors['email']}</ErrorTitle>
        </Grid>
        <Grid item xs={12} lg={6} md={6}>
          <Input
            placeholder={intl.formatMessage({
              id: 'dmo.info.consultation.phone',
            })}
            className={classes.inputTextStyle2}
            disableUnderline={true}
            name="telNumber"
            value={values.telNumber}
            onChange={
              /* istanbul ignore next */ (e) => {
                if (e.target.value !== '' && /^[0-9]+$/.test(e.target.value)) {
                  setFieldValue('telNumber', e.target.value);
                } else if (e.target.value === '') {
                  setFieldValue('telNumber', '');
                }
              }
            }
            style={{ backgroundColor: 'rgb(220, 220, 220)' }}
          />
          <ErrorTitle>{errors['telNumber'] && errors['telNumber']}</ErrorTitle>
        </Grid>
      </Grid>
    </MuiPickersUtilsProvider>
  );
};
export default ComplementInputs;
